
//Admin - Start
//Configuration

export const SERVICES_API = "services"
export const AGENTS_API = "agents"
export const CARACTERISATIONS_API ="caraterisations"
export const CARACTERISATION_ELEMETS_API ="element_caraterisation"
export const DIVISIONS_API = "divisions"
export const SECTEURS_API = "secteurs"
export const INSTITUTIONS_API = "institutions"
export const AFFECTATIONS_API = "treatments"
export const PARAMETRES_API ="parametres"
export const MOTIFS_API ="motifs"
export const CATEGORYS_API ="complaintcategories"
export const COMPLAINERS_API ="complainers"
export const PERMISSIONS_API ="permission-entities"


//Utilisateur & Profils
export const PROFILS_API ="roles"
export const USERS_API ="users"
export const RIGHTS_API ="rights"


//point focaux

export const POINTFOCAL_API ="point-focal"



//Admin - end

//Dossier

export const DOSSIER_FILTER_APIs = "dossiers?action={filter}"
export const DOSSIER_FILTER_API = "complaints/filter"
export const DOSSIER_STATS = "stats_general"
export const DOSSIER_RAPPORT_API = "rapports"
export const DOSSIER_HELP_API = "help"

export const DOSSIER_COURRIER_CREATE = "complaints"
export const DOSSIER_AUTOSAISINE_CREATE = "complaints"
export const DOSSIER_CALL_CENTER_CREATE = "complaints"
// export const DOSSIERS_API = "dossiers"
export const DOSSIERS_API = "complaints"

export const DOSSIER_DOSSIER_DU_JOUR_CREATE = "dossiers/to_follow_up/create"


//Tableau de bord

// export const DASHBOARDS_API = "dashboard"
export const DASHBOARDS_API = "complaints/stats"


//Check Auth

export const CHECK_AUTH ="me"


export const LOGIN ="login"
export const LOGIN_OSCAR ="auth/token"

export const INSTITUTIONTYPES_API = "institution-type"
export const USERACTIVITES_API = "activities/search?author_id={id}"
export const NOTIFICATIONS_API = "notifications"

export const CHAT_API = "chats"
export const STATISTIQUE_API = "complaints/stats_general"

export const IA_CONVERSATION_API = "ia/conversations"

export const IA_CLASSIFICATION_API = "ia/classification"

export const IA_RAPPORT_API = "ia/rapport"

